import { ORDER_BY_OPTIONS } from '@/feature/fundraising-advisory/competitors-funding-analysis/constants.ts'

export const DEFAULT_QUERY_ARGS = {
  page: 1,
  perPage: 25,
  orderBy: ORDER_BY_OPTIONS[0]
}
